export const synchronization = {
  TITLE: "Synchronization",
  TABS: {
    OPERATIONAL_FILES: "Operational files",
    USER_EMAILS: "User emails",
    ELASTIC_SEARCH: "Elastic Search",
  },
  COMMON: {
    SPECIFIC_FILE_NUMBERS: "Specific file numbers",
    AT_LEAST_ONE_FIELD_REQUIRED: "Number of Files for synchronization of Specific file numbers is required."
  },
  BUDGET_SUMMARY: {
    TITLE: "Budget Summary Synchronization",
    NUMBER_OF_MISSED_FILES: "Budget Summary has {{numberOfMissedBudgetSummaryFiles}} missed files.",
    NUMBER_OF_FILE_FOR_SYNC: "Number of Files for synchronization",
  },
  SUMMARY: {
    TITLE: "Summary Synchronization",
    NUMBER_OF_MISSED_FILES: "Summary has {{numberOfMissedSummaryFiles}} missed files.",
    NUMBER_OF_FILE_FOR_SYNC: "Number of Files for synchronization",
  },
  ELASTIC_SEARCH: {
    TITLE: "Elastic Search Synchronization",
  },
}
